import { AdminManagedNotice } from "@/components/permissions/admin-managed-notice";
import { useTranslation } from "react-i18next";

/**
 * OCT-22452 - what a non-admin sees in place of a subscribe, upgrade,
 * start-trial, choose-plan or billing-portal button. Those routes are
 * `withAdmin`, so the screen says who can do it instead of offering a button
 * the server refuses.
 *
 * @spec ILLEGAL E165
 */
export function AskAdminToSubscribeNotice({
  className,
  testId = "notice-ask-admin-subscribe",
}: {
  className?: string;
  testId?: string;
}) {
  const { t } = useTranslation("common");
  return (
    <AdminManagedNotice
      {...(className ? { className } : {})}
      testId={testId}
      message={t("billing.askAdminToSubscribe", { defaultValue: "Ask a workspace admin to subscribe." })}
    />
  );
}

/**
 * OCT-22452 - what a non-admin sees in place of the AI credit packages
 * (`POST /api/billing/credits/checkout` is `withAdmin`).
 *
 * @spec ILLEGAL E165
 */
export function AskAdminToBuyCreditsNotice({
  className,
  testId = "notice-ask-admin-credits",
}: {
  className?: string;
  testId?: string;
}) {
  const { t } = useTranslation("common");
  return (
    <AdminManagedNotice
      {...(className ? { className } : {})}
      testId={testId}
      message={t("billing.askAdminToBuyCredits", { defaultValue: "Ask a workspace admin to buy AI credits." })}
    />
  );
}
